import {
  Validator,
  UntypedFormControl,
  NG_VALIDATORS,
} from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[appRange][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: RangeValidator, multi: true },
  ],
})
export class RangeValidator implements Validator {
  private _range!: number[];
  @Input() set range(range: number[]) {
    this._range = range;
  }
  get range() {
    return this._range;
  }

  constructor() {}

  validate(c: UntypedFormControl) {
    if (this.range === undefined) {
      return null;
    }
    const [min, max] = this.range;
    const withinRange = c.value >= min && c.value <= max;
    const isEmpty = c.value === null || c.value === '';
    if (withinRange || isEmpty) {
      return null;
    };
    const range = {
      valid: false,
    };
    return {
      range,
    };
  }
}
